var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "counter"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.count),
      expression: "count"
    }],
    staticClass: "counter__input",
    attrs: {
      "type": "text",
      "readonly": "",
      "name": "optionsNb",
      "value": "",
      "placeholder": "?"
    },
    domProps: {
      "value": (_vm.count)
    },
    on: {
      "click": _vm.reset,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.count = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "counter__buttons"
  }, [_c('div', {
    staticClass: "counter__button counter__button--up",
    on: {
      "mouseover": _vm.mouseOver,
      "mouseleave": _vm.mouseLeave,
      "mousedown": function($event) {
        _vm.handleHold($event, function () { return _vm.count++; })
      },
      "mouseup": _vm.handleHold,
      "touchstart": function($event) {
        _vm.handleHold($event, function () { return _vm.count++; })
      },
      "touchend": _vm.handleHold
    }
  }, [_vm._v("▲")]), _vm._v(" "), _c('div', {
    staticClass: "counter__button counter__button--down",
    on: {
      "mouseover": _vm.mouseOver,
      "mouseleave": _vm.mouseLeave,
      "mousedown": function($event) {
        _vm.handleHold($event, _vm.decrement)
      },
      "mouseup": _vm.handleHold,
      "touchstart": function($event) {
        _vm.handleHold($event, _vm.decrement)
      },
      "touchend": _vm.handleHold
    }
  }, [_vm._v("▼")])])])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8d868100","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/atoms/Counter.vue
// module id = naEv
// module chunks = 1